// Mock data for Vantage Point Hospitality - Updated with premium imagery

export const mockProperties = [
  {
    id: "1",
    title: "Presidential Suite Downtown",
    location: "Dubai, UAE",
    type: "Suite",
    guests: 4,
    bedrooms: 2,
    bathrooms: 2,
    price: 450,
    currency: "USD",
    images: [
      "https://images.unsplash.com/photo-1737807478491-6e258b44bd04",
      "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800"
    ],
    amenities: ["Private Concierge", "Chef Kitchen", "Climate Control", "Infinity Pool", "Spa Access"],
    rating: 4.9,
    reviews: 127,
    description: "Exquisite presidential suite in Dubai's prestigious downtown district with panoramic city views."
  },
  {
    id: "2",
    title: "Heritage Villa Estate",
    location: "Lagos, Africa",
    type: "Villa",
    guests: 8,
    bedrooms: 4,
    bathrooms: 4,
    price: 320,
    currency: "USD",
    images: [
      "https://images.unsplash.com/photo-1566908829077-e97ace193def?w=800",
      "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800"
    ],
    amenities: ["Private Security", "Chef Kitchen", "Garden Terrace", "Wine Cellar", "Valet Parking"],
    rating: 4.8,
    reviews: 89,
    description: "Magnificent heritage villa perfect for distinguished guests visiting Lagos with modern luxury amenities."
  },
  {
    id: "3",
    title: "Manhattan Penthouse",
    location: "New York, USA",
    type: "Penthouse",
    guests: 6,
    bedrooms: 3,
    bathrooms: 3,
    price: 750,
    currency: "USD",
    images: [
      "https://images.unsplash.com/photo-1743592889729-d8a92388412e",
      "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=800"
    ],
    amenities: ["Private Elevator", "Chef Kitchen", "Executive Workspace", "Rooftop Terrace", "Butler Service"],
    rating: 4.9,
    reviews: 203,
    description: "Sophisticated Manhattan penthouse offering unparalleled luxury for discerning business travelers."
  }
];

export const mockServices = [
  {
    id: "1",
    title: "Elite Property Management",
    description: "Comprehensive luxury property management with personalized guest experiences and revenue optimization strategies.",
    features: [
      "24/7 Concierge Services",
      "Dynamic Revenue Management", 
      "White-Glove Maintenance",
      "Guest Experience Curation",
      "Performance Analytics"
    ],
    icon: "Building"
  },
  {
    id: "2", 
    title: "Premium Guest Services",
    description: "Exceptional hospitality services ensuring every guest enjoys a world-class experience during their stay.",
    features: [
      "Professional Housekeeping",
      "Same-Day Services",
      "Quality Assurance",
      "Amenity Management",
      "Emergency Response"
    ],
    icon: "Sparkles"
  },
  {
    id: "3",
    title: "Strategic Marketing", 
    description: "Expert marketing and brand positioning to maximize property visibility and attract premium guests worldwide.",
    features: [
      "Professional Photography",
      "Global Platform Management",
      "Brand Optimization",
      "Digital Marketing",
      "Performance Insights"
    ],
    icon: "TrendingUp"
  }
];

export const mockTestimonials = [
  {
    id: "1",
    name: "Daniel N.K",
    role: "Guest", 
    location: "Dubai, UAE",
    rating: 5,
    text: "Exceptional hospitality service. The property exceeded all expectations and the concierge team provided seamless support throughout our stay.",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100"
  }
];

export const mockBookings = [
  {
    id: "1",
    propertyId: "1",
    guestName: "John Anderson",
    email: "john@example.com",
    checkIn: "2024-08-15",
    checkOut: "2024-08-20",
    guests: 2,
    status: "confirmed",
    totalAmount: 2250
  }
];

export const mockAvailableDates = {
  "1": [
    "2024-08-25", "2024-08-26", "2024-08-27", "2024-08-28", "2024-08-29", "2024-08-30",
    "2024-09-01", "2024-09-02", "2024-09-03", "2024-09-05", "2024-09-06", "2024-09-07"
  ],
  "2": [
    "2024-08-20", "2024-08-21", "2024-08-22", "2024-08-24", "2024-08-25", "2024-08-26",
    "2024-09-01", "2024-09-02", "2024-09-04", "2024-09-05", "2024-09-08", "2024-09-09"
  ],
  "3": [
    "2024-08-18", "2024-08-19", "2024-08-23", "2024-08-24", "2024-08-28", "2024-08-29",
    "2024-09-02", "2024-09-03", "2024-09-04", "2024-09-06", "2024-09-07", "2024-09-10"
  ]
};
